import { withClientState } from "apollo-link-state";

const stateLink = ({ cache, defaults }) => {
  return withClientState({
    cache,
    defaults,
  });
};

export default stateLink;
